import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import { useHistory } from "react-router-dom";
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Snackbar from './Snackbar';
import { connect } from 'react-redux';
import { signIn, signInWithGoogle } from '../actions';
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles';
import { mainTheme } from '../settings';

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://seek-city.com/">
                SeekCity
            </Link>{' '}
            {new Date().getFullYear()}
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
    },
    image: {
        backgroundImage: process.env.NODE_ENV === 'development' ? 'url(https://source.unsplash.com/random)' : `url(https://firebasestorage.googleapis.com/v0/b/seekcity.appspot.com/o/social%2F${_.random(1, 12)}.jpg?alt=media&token=499fdb7f-354b-4b01-87af-adfae7b1973b)`,
        backgroundRepeat: 'no-repeat',
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'bottom',
    },
    paper: {
        margin: theme.spacing(8, 4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: '#749474',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(1, 0, 2),
    },
}));

const SignIn = (props) => {
    const [email, setEmail] = useState('');
    const classes = useStyles();
    let history = useHistory();

    return (
        <Grid container component="main" className={classes.root}>
            <CssBaseline />
            <Snackbar />
            <Grid item xs={false} sm={4} md={7} className={classes.image} />
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        SeekCity
                    </Typography>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                    <MuiThemeProvider theme={mainTheme}>
                        <Button
                            onClick={() => props.signIn(email)}
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            style={{ background: '#749474', color: 'white' }}
                        >
                            Sign In
                    </Button>
                    </MuiThemeProvider>
                    <Button
                        onClick={() => props.signInWithGoogle(history)}
                        type="submit"
                        fullWidth
                        variant="contained"
                        style={{ background: '#749474', color: 'white' }}
                    >
                        Sign In With Google
                    </Button>
                    <Box mt={5}>
                        <Copyright />
                    </Box>
                </div>
            </Grid>
        </Grid>
    );
}

export default connect(null, { signIn, signInWithGoogle })(SignIn)
